import React from "react"
import { ImageContentSectionContent, ImageContentSectionProps } from "../image/ImageContentSectionContent"
import { TextContentSectionContent, TextContentSectionProps } from "../text/TextContentSectionContent"
import { Cell, ImageContent, TextContent } from "./types"


interface Props extends Pick<ImageContentSectionProps, "editable" | "section" | "isPdf">,
    Omit<TextContentSectionProps, "content">
{
    columnWidthMd: number
    cell: Cell
}

const SectionComponent: React.FC<Props> = ({ columnWidthMd, cell, ...props  }) => {

    return (
        <div className={`col-${columnWidthMd} justify-content-end mr-1`} >
            { cell.contentType === "image" ?
                <ImageContentSectionContent  {...props} content={cell.cellContent as ImageContent}/>
                :
                <TextContentSectionContent {...props} content={cell.cellContent as TextContent}/>
            }
        </div>
    )
}

export { SectionComponent }


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/SectionContent.tsx